import { rgba } from 'polished';
import styled from 'styled-components';

import {
  colorBlack900,
  colorGrey400,
  colorPrimary600,
  colorWhite,
  fontFamilyPrimary,
  mediaQueryLaptopMax,
} from '@/styleUtils';

export const Root = styled.div`
  position: relative;
  white-space: normal;
  width: max-content;
  ${({ $isActive, $isHiddingAnimation }) =>
    $isActive && !$isHiddingAnimation && `z-index: 100`};
`;

export const ContentLabel = styled.div`
  position: relative;
`;

export const ContentLabelInner = styled.div`
  padding: ${({ $contentLabelPadding }) => `${$contentLabelPadding}px`};
  margin: ${({ $contentLabelPadding }) => `-${$contentLabelPadding}px`};
  display: flex;
  align-items: center;
`;

export const ContentLabelInnerText = styled.p`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 4px;
  color: ${({ disabled, color }) =>
    `${disabled ? colorGrey400 : color || colorBlack900}`};
  text-decoration-line: ${({ disabled }) =>
    `${disabled ? 'line-through' : 'none'}`};
`;

export const IconWrap = styled.span`
  display: inline-flex;
  vertical-align: middle;
  position: ${({ $isMobile }) => ($isMobile ? 'static' : 'relative')};
  font-size: 0;
  margin-left: ${({ $mlIconStyle }) => `${$mlIconStyle}`};
  top: ${({ $topIconStyle }) => `${$topIconStyle}`};
  color: ${({ color }) => `${color || colorGrey400}`};
  opacity: 1;
`;

export const ContentTooltip = styled.div`
  position: absolute;
  font: 12px/16px ${fontFamilyPrimary};
  z-index: 100;
  top: calc(100% + 8px);
  padding: 12px;
  background: ${colorBlack900};
  box-shadow:
    0 2px 4px ${rgba(colorGrey400, 0.08)},
    0 8px 24px ${rgba(colorGrey400, 0.24)};
  border-radius: 4px;
  color: ${colorWhite};
  width: max-content;
  max-width: 400px;
  display: none;
  animation-duration: ${({ $animationTime }) => `${$animationTime}ms`};
  animation-fill-mode: forwards;

  &.active,
  &:hover {
    display: block;
    animation-name: fadeIn;
  }

  &.hiddingAnimation {
    animation-name: fadeOut;
    pointer-events: none;
  }

  & a {
    color: ${colorPrimary600};

    &:hover {
      opacity: 0.8;
    }
  }

  &.left {
    left: 0;
  }

  ul {
    list-style: disc;
    padding-left: 10px;
  }

  &.middle {
    right: 0;
    transform: ${({ $iconWidth }) =>
      `translateX(calc(50% - ${$iconWidth / 2}px))`};
  }

  &.right {
    right: 0;
  }

  @media ${mediaQueryLaptopMax} {
    width: ${({ $marginFromViewport, $scrollbarWidth }) =>
      `calc(100vw - ${$marginFromViewport * 2 + $scrollbarWidth}px)`};
    animation-duration: ${({ $animationTime }) => `${$animationTime * 2}ms`};
    max-width: unset;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
